export default __webpack_public_path__ + "static/D-Vert-05983280f0267e68b1366dda635c012e.jpg";